import Container from './Container.vue';
import TextMarquee from './TextMarquee.vue';
export default {
  name: 'SanityLanderHeader',
  components: {
    Container,
    TextMarquee
  },
  props: {
    backdrop: {
      type: Boolean,
      default: true
    },
    showLogo: {
      type: Boolean,
      default: false
    },
    showBlackLogo: {
      type: Boolean,
      default: false
    },
    showPartnershipLogo: {
      type: Boolean,
      default: false
    },
    partnershipLogo: {
      type: String,
      default: ''
    },
    showMarquee: {
      type: Boolean,
      default: false
    },
    marqueeText: {
      type: String,
      default: ''
    }
  }
};